import React from "react";
import { Helmet } from "react-helmet";
import { ItemGridDragDropTitleStyle } from "../../components/grid-drag-drop/ItemGridDragDropTitleStyle";
import { Grid, IconButton } from "@material-ui/core";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { LightTooltip, Margin } from "../../styles/GlobalStyle";
import CachedOutlinedIcon from "@material-ui/icons/CachedOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { DividerStyled } from "../../components/chat/styles/GeneralStyle";
import useDashboardViewController from "../../pages/dashboard/controllers/DashboardViewController";

export const WidgetVersion71 = () => {
  const { handleDeleteWidgets } = useDashboardViewController();

  const item = {
    i: "71",
    importScripts: [""],
    stringScripts: [
      `try{ let GRINtoken=localStorage.getItem("tokenCognitoPanel"), GRINdocument=localStorage.getItem("documentPanel"); const GRINShowError=()=>{if (document.getElementById("GRINfetchError")){document.getElementById("GRINfetchError").style.display="flex"; document.getElementById("GRINloaderAnimation").style.display="none"; document.getElementById("GRINwidGet").style.display="none";}}; const GRINnoticesRequests=(GRINuser)=> ({requests: [{requestValue: async ()=>{let GRINtickets=await fetch( \`https://crmcont.qyon.com/api-be/v1/ticket?attendantId=\${GRINuser.attendantId}&lastInterationsByCustomer=true\`,{headers:{"qyon-customer-cnpj": GRINdocument, Authorization: GRINtoken,},}) .then((res)=> res.json()) .catch((error)=>{console.log( "[error][widget][GR][important-notices] new interacts", error ); GRINShowError();}); return GRINtickets.items.length;}, description: "Tickets meus com novas interações",},{requestValue: async ()=>{let today=new Date(); let yesterday=new Date(); yesterday.setDate(today.getDate() - 1); let GRINTasksYesterday=await fetch( \`https://crmcont.qyon.com/api-be/v1/task?assigneeId=\${GRINuser.attendantId}&endDueDate=\${yesterday.toISOString().split("T")[0]}&taskCompleted=false\`,{headers:{"qyon-customer-cnpj": GRINdocument, Authorization: GRINtoken,},}) .then((res)=> res.json()) .catch((error)=>{console.log( "[error][widget][GR][important-notices] late tasks", error ); GRINShowError();}); return GRINTasksYesterday.items.length;}, description: "Tarefas atrasadas",},{requestValue: async ()=>{let GRINTasksToday=await fetch( \`https://crmcont.qyon.com/api-be/v1/task?assigneeId=\${GRINuser.attendantId}&startDueDate=\${new Date().toISOString().split("T")[0]}&taskCompleted=false\`,{headers:{"qyon-customer-cnpj": GRINdocument, Authorization: GRINtoken,},}) .then((res)=> res.json()) .catch((error)=>{console.log( "[error][widget][GR][important-notices] tasks today", error ); GRINShowError();}); return GRINTasksToday.items.length;}, description: "Tarefas pra hoje",},{requestValue: async ()=>{let tomorrow=new Date(); let sevenDaysTasks=new Date(); sevenDaysTasks.setDate(sevenDaysTasks.getDate() + 7); tomorrow.setDate(tomorrow.getDate() + 1); let GRINTasksSevenDays=await fetch( \`https://crmcont.qyon.com/api-be/v1/task?assigneeId=\${GRINuser.attendantId}&startDueDate=\${tomorrow.toISOString().split("T")[0]}&endDueDate=\${sevenDaysTasks.toISOString().split("T")[0]}&taskCompleted=false\`,{headers:{"qyon-customer-cnpj": GRINdocument, Authorization: GRINtoken,},}) .then((res)=> res.json()) .catch((error)=>{console.log( "[error][widget][GR][important-notices] getting next tasks", error ); GRINShowError();}); return GRINTasksSevenDays.items.length;}, description: "Tarefas próximas ao vencimento (7 dias)",},],}); const GRINgetUserByToken=async ()=>{const GRINUser=await fetch( "https://crmcont.qyon.com/api-be/v1/auth",{headers:{"qyon-customer-cnpj": GRINdocument, Authorization: GRINtoken,},}) .then((res)=> res.json()) .catch((error)=>{console.log( "[error][widget][GR][important-notices] getting user", error ); GRINShowError();}); return{companyId: GRINUser.company.id, attendantId: GRINUser.identifiers.userId, customerId: GRINUser.identifiers.customerId, customerContactId: GRINUser.identifiers.customerContactId,};}; const GRINgetImportanWarnng=async ()=>{let GRINuser=await GRINgetUserByToken().catch((error)=>{console.log( "[error][widget][GR][important-notices] getting user", error ); GRINShowError();}); let GRINlistImportantNotices=GRINnoticesRequests( GRINuser ).requests.map(async (GRINnotice)=> ({quantity: (await GRINnotice.requestValue().catch((error)=>{console.log( "[error][widget][GR][important-notices] requesting infos", error ); GRINShowError();})) || 0, ...GRINnotice,})); document.getElementById("GRINwidGet").innerHTML=GRINrenderContent( await Promise.all(GRINlistImportantNotices) );}; const GRINrenderContent=(GRINjson)=>{const GRINrenderList=(GRINimportantNotices)=>{return GRINimportantNotices.map( (GRINvalue)=> \` <div style="display: inline-flex;align-items: left;width: inherit;"> <div style="color: #ffffff; font: normal normal bold 14px/16px Ubuntu; text-align: center; width: 40px; height: 40px; line-height: 40px; background: #0A73DB; border-radius: 5px;transform: translateY(+25%);"> \${GRINvalue.quantity}</div><div style="padding: 20px; text-align: initial;"> \${GRINvalue.description}</div></div><div style="border-bottom: #E5E5E5 solid 1px; overflow: auto;"></div>\` ).join("");}; return \`\${GRINrenderList(GRINjson)}\`;}; try{(async ()=>{await GRINgetImportanWarnng(); document.getElementById("GRINloaderAnimation").style.display="none";})();}catch (error){console.log( "[error][widget][GR][important-notices] main function ", error ); GRINShowError();}}catch(err){}`,
    ],
    onRefresh: "",
    refreshOnLoad: true,
  };

  return (
    <>
      {item.importScripts.map((script, index) => {
        return (
          <div key={`import_${index}`}>
            <Helmet>
              <script async src={script}></script>
            </Helmet>
          </div>
        );
      })}

      <ItemGridDragDropTitleStyle customStyle={item.headerStyle ?? {}}>
        <Grid item container justifyContent="space-between" alignItems="center">
          <Grid item flex={1}>
            <IconButton size="small">
              <DragIndicatorIcon style={{ fontSize: 18, marginRight: 5 }} />
            </IconButton>
            Notícias Importantes
          </Grid>
          <Grid item flex={1}>
            <Grid item container alignItems="center">
              <Margin top="7" />
              {item.onRefresh &&
                (() => {
                  if (item?.refreshOnLoad) {
                    setTimeout(() => {
                      try {
                        // eslint-disable-next-line no-eval
                        eval("try{" + item.onRefresh + "}catch(err){}");
                      } catch (error) {
                        console.error(error);
                      }
                    }, 1500);
                  }

                  return (
                    <Grid item flex={1}>
                      <LightTooltip title="Atualizar">
                        <CachedOutlinedIcon
                          style={{
                            fontSize: 18,
                            marginRight: 10,
                            cursor: "pointer",
                            color: "#636363",
                          }}
                          onClick={() => {
                            // Muito cuidado, o eval é perigoso - https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/eval
                            try {
                              // eslint-disable-next-line no-eval
                              eval("try{" + item.onRefresh + "}catch(err){}");
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      </LightTooltip>
                    </Grid>
                  );
                })()}
              <Grid item flex={1}>
                <LightTooltip title="Remover">
                  <CloseIcon
                    style={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: "#636363",
                      marginRight: 10,
                    }}
                    onClick={() => handleDeleteWidgets(item)}
                  />
                </LightTooltip>
              </Grid>
            </Grid>
          </Grid>
          <DividerStyled style={{ width: "100%" }} />
        </Grid>
      </ItemGridDragDropTitleStyle>

      <div
        style={{
          height: `${"calc(100% - 65px)"}`,
          width: "100%",
        }}
      >
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Ubuntu&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons+Round"
          rel="stylesheet"
        />
        <style>{`
        @keyframes GRINspinner-grow {
          0% { transform: scale(0); }
          50% { opacity: 1; transform: none; }
        }
      `}</style>

        <body
          style={{
            backgroundColor: "white",
            margin: 0,
            height: "100%",
            width: "100%",
          }}
        >
          <div
            id="GRIN_widget"
            style={{
              height: "calc(100% - 58.33px)",
              fontFamily: "'Ubuntu', sans-serif",
              padding: "0 10px 10px 10px",
              position: "relative",
            }}
          >
            <div
              id="GRINloaderAnimation"
              style={{
                color: "#0d6efd",
                display: "block",
                width: "5rem",
                height: "5rem",
                verticalAlign: "-0.125em",
                backgroundColor: "currentColor",
                borderRadius: "50%",
                opacity: 0,
                animation: "0.75s linear infinite GRINspinner-grow",
                animationDuration: "1.5s",
                position: "absolute",
                top: "calc(50% - 2.5rem)",
                left: "calc(50% - 2.5rem)",
              }}
            ></div>
            <div
              id="GRINfetchError"
              style={{
                position: "absolute",
                width: "calc(100% - 20px)",
                height: "100%",
                display: "none",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                className="material-icons-round"
                style={{ fontSize: "3em", margin: "8px" }}
              >
                error_outline
              </span>
              <p>
                Não foi possível carregar os dados
                <br />
                Tente novamente
              </p>
            </div>
            <div
              id="GRINwidGet"
              style={{
                paddingRight: "30px",
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                flexDirection: "column",
                textAlign: "left",
                width: "100%",
                margin: "auto",
                top: "60%",
                transform: "translateY(-50%)",
              }}
            ></div>
          </div>
        </body>
      </div>

      {item.stringScripts &&
        item.stringScripts.map((script, index) => {
          return (
            <div key={`script_${index}`}>
              <Helmet>
                <script async>{script}</script>
              </Helmet>
            </div>
          );
        })}
    </>
  );
};
